import type { RouteObject } from 'react-router';

import { PERMISSIONS } from '@/constants/permissions';
import { ROUTES } from '@/constants/routes';
import { RequirePermission } from '@/features/auth';

export const staffRoutes: RouteObject[] = [
  {
    element: <RequirePermission permission={PERMISSIONS.USERS_MANAGE} />,
    children: [
      {
        path: ROUTES.STAFF,
        lazy: async () => ({ Component: (await import('./pages/StaffPage')).StaffPage }),
      },
    ],
  },
  {
    element: <RequirePermission permission={PERMISSIONS.ROLES_MANAGE} />,
    children: [
      {
        path: ROUTES.ROLES,
        lazy: async () => ({ Component: (await import('./pages/RolesPage')).RolesPage }),
      },
    ],
  },
];
